import axios from "axios";
import ApiService from "./ApiService";
import { Cookies } from 'quasar';

class EServiceDataService extends ApiService {

    async getManulifePages(){
        return [
            {
                "name_en": "Home",
                "name_zh": "主頁",
                "remarks_en": "Eligibility of services is subject to the medical plan chosenInformation may vary from time to time. So, please call our Customer Hotline for the most updated information.Customer Hotline: (852) 8200-8223",
                "remarks_zh": "可享有之服務範圍以閣下所選之醫療計劃為準。醫療網絡資料或會作出更改，煩請閣下致電本公司的客戶熱線查詢最新的醫療網絡醫生資料。客戶熱線：(852) 8200-8223",
                "timestamp": 0,
                "route": "home"
            },
            {
                "name_en": "Premier Lifestyle / Premier Lady",
                "name_zh": "寫意生活",
                "remarks_en": null,
                "remarks_zh": null,
                "timestamp": 1,
                "route": "premier"
            },
            {
                "name_en": "Vita, MyChoice, ManuCritical Care , ManuMulti Care, ManuTotal Care , ManuBright Care , ManuPrime Care, ManuEssential Care",
                "name_zh": "活得精彩危疾保 | 理想退休入息計劃 | 自在生活危疾保 | 樂享人生危疾保 | 樂活無憂危疾保 | 活耀人生危疾保 | 樂健無憂危疾保 | 樂康無憂危疾保",
                "remarks_en": null,
                "remarks_zh": null,
                "timestamp": 2,
                "route": "vita_mychoice"
            },
            {
                "name_en": "ManuMaster Healthcare* / ManuShine Healthcare*",
                "name_zh": "晉領醫療保障 / 活亮人生醫療保障*",
                "remarks_en": "Remarks: * ManuMaster / ManuShine Healthcare is referring to ManuMaster Healthcare Series or ManuShine Healthcare Series or ManuMaster Healthcare Benefit or ManuShine Healthcare Benefit.",
                "remarks_zh": "備註: * 「晉領 / 活亮人生醫療保障」是指「晉領醫療保障系列」或「活亮人生醫療保障系列」或「晉領醫療附加保障」或「活亮人生醫療附加保障」。",
                "timestamp": 3,
                "route": "healthcare"
            },
            {
                "name_en": "Cancer Guard Protection Benefit",
                "name_zh": "守護安心癌症附加保障",
                "remarks_en": null,
                "remarks_zh": null,
                "timestamp": 4,
                "route": "benefit"
            },
            {
                "name_en": "Health Tips Video",
                "name_zh": "健康小Tips短片",
                "remarks_en": "https://www.qhms.com/en/health-info/health-videos",
                "remarks_zh": "https://www.qhms.com/health-info/health-videos",
                "timestamp": 5,
                "route": "tips"
            },
            {
                "name_en": "Logout",
                "name_zh": "登出",
                "remarks_en": null,
                "remarks_zh": null,
                "timestamp": 6,
                "route": "logout"
            }
        ];
    }

    async getManulifeMappingFile(){

        var data = {}
        const accessToken = Cookies.get('accessToken')

        return await axios.post( this.baseUrl() + "/eservice/getManulifeMappingFile", data, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'accessToken' : accessToken
            }
        });
    }

    async getManulifeBenefit(){
        var data = { }
        const accessToken = Cookies.get('accessToken')

        return await axios.post(this.baseUrl() + "/eservice/getManulifeBenefit", data, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'accessToken' : accessToken
            }
        });
    }

    async getManulifeHealthcare(){
        var data = {}
        const accessToken = Cookies.get('accessToken')

        return await axios.post(this.baseUrl() + "/eservice/getManulifeHealthcare", data, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'accessToken' : accessToken
            }
        });
    }

    async getManulifePremierPlans(){
        var data = {}
        const accessToken = Cookies.get('accessToken')

        return await axios.post(this.baseUrl() + "/eservice/getManulifePremierPlans", data, {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'accessToken' : accessToken
            }
        });
    }
}

export default new EServiceDataService();